export const getCategoria = state => {
  return state.grpr
}

export const getCodArrecadacao = state => {
  return state.loadingParcelamento
}
